'use strict';

ebQueryDefaults.$inject = [];

function ebQueryDefaults() {
    return {
        restrict: 'E',
        templateUrl: require('./ebQueryDefaults.html'),
        scope: {
            sourceObj: '=',
            storageObj: '='
        }
    };
}

module.exports = ebQueryDefaults;



//////////////////
// WEBPACK FOOTER
// ./source/angular/components/admin/directives/ebQueryDefaultsDirective.js
// module id = 40
// module chunks = 0